import { render, staticRenderFns } from "./SelectActionItems.vue?vue&type=template&id=5b136edb&scoped=true&"
import script from "./SelectActionItems.vue?vue&type=script&lang=js&"
export * from "./SelectActionItems.vue?vue&type=script&lang=js&"
import style0 from "./SelectActionItems.vue?vue&type=style&index=0&id=5b136edb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b136edb",
  null
  
)

export default component.exports